import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis, scrollToId } from "@/lib/api";

export const useSmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let frame;
    let scrollTimer;
    const loop = (time) => { lenis.raf(time); frame = requestAnimationFrame(loop); };
    frame = requestAnimationFrame(loop);
    if (sessionStorage.getItem("pepe_scroll_avis")) {
      scrollTimer = setTimeout(() => {
        sessionStorage.removeItem("pepe_scroll_avis");
        scrollToId("#avis");
      }, 600);
    }
    return () => { clearTimeout(scrollTimer); cancelAnimationFrame(frame); lenis.destroy(); setLenis(null); };
  }, []);
};